import { Context, createContext } from 'react';
import { IAppContext } from '../interfaces/bookingContext';

export const AppContext: Context<IAppContext> = createContext<any>({});
